import gameNames from '../../hub/data/GameIds';

export const initialState = {
  // direct props from curriculum json
  questionId: null,
  targetWord: null,
  targetOnset: null,
  targetRime: null,
  correctAnswers: [],
  // props calculated during questions initialization
  botsPerSide: null,
  bots: [],
  // props calculated during game
  userAnswers: [null, null],
  isOnsetAnswerCorrect: null,
  isRimeAnswerCorrect: null,
  isAnswerCorrect: null,
  attemptsCount: 0,
};

const dragdropReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.WORDBOTS) {
    return state;
  }

  switch (action.type) {
    case 'WORDBOTS_INIT_QUESTION': {
      return {
        ...initialState,
        ...action.payload,
      };
    }
    case 'WORDBOTS_PROVIDE_STANDARD_ANSWER': {
      const {
        bots,
        userAnswers,
        isOnsetAnswerCorrect,
        isRimeAnswerCorrect,
        isAnswerCorrect,
        isAnswerComplete,
      } = action.payload;

      return {
        ...state,
        bots,
        userAnswers,
        isOnsetAnswerCorrect,
        isRimeAnswerCorrect,
        isAnswerCorrect,
        attemptsCount: isAnswerComplete ? state.attemptsCount + 1 : state.attemptsCount,
      };
    }
    case 'WORDBOTS_PROVIDE_ONBOARDING_ANSWER': {
      const { bots, attemptsCount, isAnswerCorrect } = action.payload;

      return {
        ...state,
        bots,
        // actually we don't need this property on Onboarding, but let it be just set correct:
        // if this is 1st attempt, there is only onset user answer [1, null], if 2nd - both [1, 0]
        userAnswers: attemptsCount === 2 ? [1, 0] : [1, null],
        // same here, onset answer is always correct if it was provided
        isOnsetAnswerCorrect: attemptsCount > 0,
        // same here, rime answer is always correct if it was provided
        isRimeAnswerCorrect: attemptsCount > 1,
        isAnswerCorrect,
        attemptsCount,
      };
    }
    case 'WORDBOTS_PROVIDE_PRACTICE_ANSWER': {
      const {
        bots,
        userAnswers,
        isOnsetAnswerCorrect,
        isRimeAnswerCorrect,
        attemptsCount,
      } = action.payload;

      return {
        ...state,
        bots,
        userAnswers,
        isOnsetAnswerCorrect,
        isRimeAnswerCorrect,
        isAnswerCorrect: isOnsetAnswerCorrect && isRimeAnswerCorrect,
        attemptsCount,
      };
    }
    default:
      return state;
  }
};

export default dragdropReducer;
